"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Collection = _interopRequireDefault(require("@deosite/ui-entities/Collection"));
var _prismicReactjs = require("prismic-reactjs");
var __jsx = _react["default"].createElement;
var CollectionDetails = function CollectionDetails(props) {
  var collection = props.collection;
  var title = collection.title,
    content = collection.content;
  return __jsx(_Box["default"], {
    sx: {
      py: "s9"
    }
  }, title && __jsx(_Box["default"], {
    as: "h5",
    sx: {
      textAlign: "left",
      font: "heading3",
      mb: "s7"
    }
  }, title), __jsx(_Box["default"], {
    sx: {
      textAlign: "left",
      font: "body",
      li: {
        mt: "s7",
        listStyleType: "disc",
        pl: "s5"
      },
      ul: {
        pl: "s8"
      },
      p: {
        mt: "s5"
      },
      h5: {
        font: "heading3",
        mb: "s7"
      },
      a: {
        color: "main"
      }
    }
  }, _prismicReactjs.RichText.render(content)));
};
var _default = CollectionDetails;
exports["default"] = _default;